
export const keycloakConfig = {
  useKeycloak: window.RUNTIME_CONFIG.VUE_APP_USE_KEYCLOAK === "true",
  url: window.RUNTIME_CONFIG.VUE_APP_KEYCLOAK_URL,
  realm: window.RUNTIME_CONFIG.VUE_APP_KEYCLOAK_REALM,
  clientId: window.RUNTIME_CONFIG.VUE_APP_KEYCLOAK_CLIENT_ID,
  onLoad: "login-required",
};
